import { render, staticRenderFns } from "./AddressesTable.vue?vue&type=template&id=294ec0a8&"
import script from "./AddressesTable.vue?vue&type=script&lang=js&"
export * from "./AddressesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports